import { createContext } from 'react';
import { ModalContextProps } from './model/ModalContextProps';

const ModalContext = createContext<ModalContextProps>({
  modal: () => {},
  closeModal: () => {},
});

export default ModalContext;
